enum TireSeason {
  SUMMER = 2,
  WINTER = 1,
  ALL = 3,
}

export default TireSeason;
